/** @typedef {"diagnose" | "drug" | "fertilize" | "observation" | "other" | "watering"} Task */
export const TASKS = {
  diagnose: "diagnose",
  drug: "drug",
  fertilize: "fertilize",
  observation: "observation",
  other: "other",
  watering: "watering",
};

export const OPERATIONS = {
  DIAGNOSE: {
    ON_SITE_TESTING: "onSiteTesting", // Επιτόπιος διαγνωστικός έλεγχος
    SOIL_SAMPLING: "soilSampling", // Δειγματοληψία εδάφους
    LEAF_ANALYSIS: "leafAnalysis", // Φυλλοδιαγνωστική ανάλυση
    INSECT_MONITORING: "insectMonitoring", // Παρακολούθηση εντόμων
    LAB: "lab", // Εργαστηριακός έλεγχος
  },
  OTHER: {
    BALE: "bale", // Δεματοποίηση
    EMBEDDING: "embedding", // Ενσίρωση
    ERADICATION: "eradication", // Εκρίζωση
    HARVEST: "harvest", // Συγκομιδή
    LAWN: "lawn", // Χορτοκοπή
    MULCH: "mulch", // Εδαφοκάλυψη
    PLANTING: "planting", // Φύτευση
    PLOWING: "plowing", // Άροση
    PROPAGATING_MATERIAL: "propagatingMaterial", // Χρήση υγιούς πολλαπλασιαστικού υλικού
    PRUNING: "pruning", // Κλάδεμα
    REPRODUCTIVE_MATERIAL: "reproductiveMaterial", // Αναπαραγωγικό υλικό
    SOWING: "sowing", // Σπορά
    STIRRING: "stirring", // Ανάδευση
    SUN_DISINFECTION: "sunDisinfection", // Ηλιοαπολύμανση
    WEEDING: "weeding", // Βοτάνισμα
    WRAPPING: "wrapping", // Περιτύλιξη δεμάτων
  },
};

/** @typedef {'performed' | 'suggested' | 'failed'} ActionStatus */
export const ACTION_STATUS = {
  performed: "performed",
  suggested: "suggested",
  failed: "failed",
};
